import * as React from "react"

import { convertToValidId } from "libs/utils/dom"

import { UiColor } from "styleguide/styles/colors"
import SvgIcon from "./SvgIcon/SvgIcon"

export interface SvgProps {
  color?: UiColor
  className?: string
  title?: string
  viewBoxWidth?: number
  viewBoxHeight?: number
  id?: string
}

interface SvgTemplateProps {
  children?: React.ReactNode
  title: string
  viewBoxWidth: number
  viewBoxHeight: number
  id?: string
}

const Svg = ({
  children,
  title,
  viewBoxWidth,
  viewBoxHeight,
  ...otherProps
}: SvgTemplateProps) => {
  const svgId = otherProps.id
    ? convertToValidId(`svg-${title}`, otherProps.id)
    : convertToValidId(
        `svg-${title}`,
        Math.floor(Math.random() * 1000).toString()
      )

  return (
    <svg
      {...otherProps}
      viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby={svgId}
    >
      <title id={svgId}>{title}</title>
      {children}
    </svg>
  )
}

Svg.Icon = SvgIcon

export default Svg
